// extracted by mini-css-extract-plugin
export default {"modalCloseButton":"ApproveModal_modalCloseButton__CuTgI","modal":"ApproveModal_modal__IYXq8"};